module.exports = __webpack_public_path__ + "img/weather63.de011fcb.png";